export default {
    headerParagraph: 'اهلا بكم في اعلاء العضوية يمكنك اختيار المدة المناسبة لك حتى يتم الاشتراك',
    activate: 'اعلاء العضوية',
    firstPlanTitle: 'الاختيار الاول',
    firstPlanP1: 'سنة كاملة اشتراك.',
    firstPlanP2: 'عند الاشتراك مدة سنة كاملة تحصل مباشرة على 6 اشهر اضافية مجانية.',
    firstPlanPrice: '150 دولار',
    secondPlanTitle: 'الاختيار الثاني',
    secondPlanP1: 'اشتراك 6 اشهر.',
    secondPlanP2: 'عند الاشتراك مدة 6 اشهر تحصل مباشرة على 3 اشهر اضافية مجانية.',
    secondPlanPrice: '100 دولار'
}
